<template>
  <div>
    <div>
      <vue-pdf :src="pdfUrl"  />
    </div>
    <button @click="downloadPdf">download PDF</button>
  </div>
</template>

<script>
import VuePdf from 'vue-pdf';

export default {
  components: {
    VuePdf,
  },
  data() {
    return {
      pdfUrl: 'pdf/road_map.pdf', // 或者 PDF 文件的 URL
    };
  },
  methods: {
    downloadPdf() {
      // 兼容 Android 和 iOS
      if (this.isIOS()) {
        this.downloadPdfForIOS();
      } else {
        this.downloadPdfForAndroid();
      }
    },

// 安卓直接创建 <a> 标签下载
    downloadPdfForAndroid() {
      const link = document.createElement('a');
      link.href = this.pdfUrl;
      link.download = 'road_map.pdf'; // 设置下载文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

// iOS 需要先 fetch 下载，再创建 <a> 标签
    async downloadPdfForIOS() {
      try {
        const response = await fetch(this.pdfUrl);
        if (!response.ok) throw new Error("下载 PDF 失败");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = 'road_map.pdf'; // 设置下载文件名

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(blobUrl); // 释放 Blob URL，避免内存泄漏
      } catch (error) {
        console.error('下载 PDF 失败:', error);
      }
    },

// 判断是否是 iOS 设备
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }
  },
};
</script>

<style lang="scss" scoped>
@use 'styles/common' as *;
/* 添加你的样式 */
button {
  padding: .3vw;
  position: absolute;
  top: 1vw;
  right: 1vw;
  font-size: 1vw;
  @include respond-to() {
    //padding: .5vw;
    //position: unset;
    //top: 1.2vw;
    //right: 1.2vw;
    font-size: 5vw;
  }
}

</style>
